import { z } from 'zod'

import { StripeApi } from '../api'
import { getApiConfig } from './api-config'

const stripePortalSessionSchema = z.string()

export async function createPortalSession() {
  const api = new StripeApi(getApiConfig())
  const portalSession = await api.apiStripePortalsessionPost()
  return stripePortalSessionSchema.parse(portalSession)
}

/**
 * Creates a portal session that sends the user directly to the cancellation flow.
 * Uses manual fetch because the Swagger spec does not expose the `flow` query parameter.
 */
export async function createCancelPortalSession() {
  const config = getApiConfig()
  const response = await fetch(
    `${config.basePath}/api/stripe/portalsession?flow=subscription_cancel`,
    {
      method: 'POST',
      headers: {
        ...(config.headers ?? {}),
      },
    },
  )
  if (!response.ok) {
    const text = await response.text().catch(() => '')
    throw new Error(text || `Portal session failed: ${response.status}`)
  }
  const portalSession = await response.text()
  return stripePortalSessionSchema.parse(portalSession)
}
